import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { AssignedDeviceForm } from '@/components/forms/AssignedDeviceForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateAssignedDevicePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Assign New Device</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Assign a new device to a user.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <AssignedDeviceForm
              onSuccess={() => navigate('/user-management/assigned-devices')}
              onCancel={() => navigate('/user-management/assigned-devices')}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
